import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { useApi, ago } from "@/lib/api";

const friendly = (e) =>
  e.includes("insufficient_credits") ? "Emergent credits ran out — add balance under Universal Key to resume emails"
    : e.includes("integration_disabled") ? "Email integration is turned off in Emergent"
    : e.includes("daily_limit") ? "Daily email spend limit reached" : e;

export const AlertsLogPanel = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => { api("get", "/admin/alerts/log").then(setD).catch(() => {}); }, [api]);
  if (!d) return null;
  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5" data-testid="admin-alerts-panel">
      <h2 className="font-display text-lg font-bold mb-1 flex items-center gap-2"><Bell className="w-4 h-4 text-blue-400" />Tip alerts</h2>
      <p className="text-sm text-slate-400 mb-2" data-testid="alerts-subscriber-count">{d.subscribers} member(s) subscribed. Emails send when you publish a race.</p>
      {d.log.map((l) => (
        <p key={l.id} className="text-xs py-1 border-t border-white/5 text-slate-400">
          {l.track} R{l.race} · {l.sent}/{l.subscribers} sent · {ago(l.at)}
          {l.error && <span className="block text-rose-300">{friendly(l.error)}</span>}
        </p>
      ))}
    </section>
  );
};
